<template>
    <span v-if="mostrarBtnAprovar || mostrarBtnReprovar">
        <b-button
            variant="primary"
            @click.stop="confirmarAprovarReprovarEntrega('A')"
            v-if="mostrarBtnAprovar"
        >
            <span> <i class="fa fa-check-circle"></i> Aprovar </span>
        </b-button>
        <b-button
            variant="danger"
            @click.stop="abrir()"
            v-if="mostrarBtnReprovar"
            class="ml-2"
        >
            <span> <i class="fa fa-times-circle"></i> Reprovar </span>
        </b-button>
        <b-modal v-model="mostrarModal">
            <div slot="modal-title">
                Consultoria - Reprovação - Justificativa
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa</label>
                        <b-form-textarea
                            v-model="justificativa"
                            :rows="4"
                            @input="$v.justificativa.$touch()"
                            :state="$v.justificativa.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa é
                            obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fechar()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="danger"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarAprovarReprovarEntrega('R')"
                    class="ml-2"
                >
                    <span> <i class="fa fa-times-circle"></i> Reprovar </span>
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { consultoriaStatus } from '../../ConsultoriaStatus'
import { StatusComprometimento } from './StatusComprometimento'

export default {
    props: {
        consultoria: {
            type: Object,
            default: () => ({})
        },

        services: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            erros: [],
            mostrarModal: false,
            justificativa: ''
        }
    },

    methods: {
        abrir() {
            this.mostrarModal = true
        },

        fechar() {
            this.mostrarModal = false
            this.justificativa = ''
        },

        confirmarAprovarReprovarEntrega(acao) {
            let acaoTitulo
            let acaoMensagem
            let html

            if (acao === 'A') {
                acaoTitulo = 'Aprovar'
                acaoMensagem = 'aprovação'
                html = `Confirma a ${acaoMensagem} da consultoria?
                <br/><br/><div class="alert alert-danger" role="alert">
                <div class="row">
                            <div class="col-3">
                                <i class="fa fa-exclamation-circle fa-5x"></i>
                            </div>
                            <div class="col-9">
                                <h4>A aprovação desta consultoria valida a execução dos serviços prestados de acordo
                                com os documentos comprobatórios inseridos na mesma.</h4>
                            </div>
                        </div>
		             </div>`
            } else {
                acaoTitulo = 'Reprovar'
                acaoMensagem = 'reprovação'
                html = `Confirma a ${acaoMensagem} da consultoria?`
            }

            this.$swal({
                title: `${acaoTitulo} Consultoria`,
                html: html,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.aprovarReprovar(acao)
                }
            })
        },

        aprovarReprovar(acao) {
            this.$store.dispatch('addRequest')
            let consultoriaDto = {
                consultoriaId: this.$route.params.consultoriaId,
                acao: acao,
                justificativa: this.justificativa
            }
            this.services
                .aprovarReprovarConsultoria(consultoriaDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Consultoria processada com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterConsultoriaAtualizada')
                        } else {
                            this.$toast.error(
                                'Erro ao processar solicitação',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnReprovar() {
            let retorno =
                this.$temAcesso('APPSE-GEST-CONS-00') &&
                this.consultoria.status ===
                    consultoriaStatus.CONCLUIDA_EM_ANALISE &&
                this.consultoria.statusComprometimento ===
                    StatusComprometimento.COMPROMETIDO
            return retorno
        },

        mostrarBtnAprovar() {
            let retorno =
                this.$temAcesso('APPSE-GEST-CONS-00') &&
                this.consultoria.status ===
                    consultoriaStatus.CONCLUIDA_EM_ANALISE &&
                this.consultoria.statusComprometimento ===
                    StatusComprometimento.COMPROMETIDO
            return retorno
        },

        mostrarMsgErroComprometimento() {
            let retorno =
                this.$temAcesso('APPSE-GEST-CONS-00') &&
                this.consultoria.status ===
                    consultoriaStatus.CONCLUIDA_EM_ANALISE &&
                this.consultoria.statusComprometimento !==
                    StatusComprometimento.COMPROMETIDO
            return retorno
        }
    },

    validations: {
        justificativa: {
            required
        }
    }
}
</script>
